import { render, staticRenderFns } from "./ShoppableInstagram.vue?vue&type=template&id=4f4da7b4&scoped=true&lang=pug&"
import script from "./ShoppableInstagram.vue?vue&type=script&lang=js&"
export * from "./ShoppableInstagram.vue?vue&type=script&lang=js&"
import style0 from "./ShoppableInstagram.vue?vue&type=style&index=0&id=4f4da7b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4da7b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f4da7b4')) {
      api.createRecord('4f4da7b4', component.options)
    } else {
      api.reload('4f4da7b4', component.options)
    }
    module.hot.accept("./ShoppableInstagram.vue?vue&type=template&id=4f4da7b4&scoped=true&lang=pug&", function () {
      api.rerender('4f4da7b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/sections/ShoppableInstagram.vue"
export default component.exports